import type { MailboxInfo } from 'owa-client-types';
import { debugErrorThatWillShowErrorPopupOnly } from 'owa-trace';

export type SuggestedDraftCallbackInputFuncType = (
    requestId: string
) => (
    itemId: string,
    conversationId: string,
    mailboxInfo: MailboxInfo,
    suggestion: string,
    index: number,
    isCustom: boolean
) => void;

export type SuggestedDraftCallbackFuncType = ReturnType<SuggestedDraftCallbackInputFuncType>;

const scenarioToCallbackMap = new Map<string, SuggestedDraftCallbackFuncType>();

export function invokeCallbackBasedOnScenario(
    scenario: string,
    itemId: string,
    conversationId: string,
    mailboxInfo: MailboxInfo,
    suggestion: string,
    index: number,
    isCustom: boolean
): void {
    const callback = scenarioToCallbackMap.get(scenario);
    if (!!callback) {
        callback(itemId, conversationId, mailboxInfo, suggestion, index, isCustom);
    } else {
        debugErrorThatWillShowErrorPopupOnly(
            `Copilot SuggestedDrafts Callback scenario ${scenario} is not defined.`
        );
    }
}

export function registerCallback(scenario: string, callback: SuggestedDraftCallbackFuncType): void {
    scenarioToCallbackMap.set(scenario, callback);
}
